<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="跟台使用单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>跟台使用单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="仓库" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseManagerId" label="库管员" v-if="getIsView()">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>库管员:{{ form.warehouseManagerName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item> 
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-select v-model="form.patientNo" filterable :filter-method="getPatientDetailList"
                  @change="patientChange" :disabled="!editMode" style="width: 100%">
                  <el-option v-for="item in STATIC_PatientDetails" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientId" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者姓名:{{ form.patientName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientDeptName" label="患者科室" v-if="getIsView()">
                <el-input disabled v-model="form.patientDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者科室:{{ form.patientDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deptName" label="执行科室" v-if="getIsView()">
                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" :id="'idGroup'" placeholder="请选择"
                  :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards"
                  @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup"
                    :label="item.deptNo + ' ' + item.deptName + ' ' + (item.wardName ? item.wardName : '')"
                    :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.deptName" placeholder="请选择" :id="'deptId'" :disabled="!editMode"
                  filterable :filter-method="getDeptsBySessionDeptId" @change="deptChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>执行科室:{{ form.deptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeDeptName" label="计费科室" v-if="getIsView()">
                <el-select v-if="system_setting.IsUseWard" v-model="form.chargeDeptName" placeholder="请选择"
                  :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards1"
                  @change="chargeDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards1" :key="item.idGroup"
                    :label="item.deptNo + ' ' + item.deptName + ' ' + (item.wardName ? item.wardName : '')"
                    :value="item.idGroup"></el-option>
                </el-select>

                <el-select v-else v-model="form.chargeDeptName" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getDepts2" @change="chargeDeptChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Depts1" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>计费科室:{{ form.chargeDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="isOutPatient" label="是否门诊" v-if="getIsView()">
                <el-radio-group :disabled="!editMode" v-model="form.isOutPatient">
                  <el-switch v-model="form.isOutPatient" active-color="#286AB4" inactive-color="#D4D4D4"
                    :active-value="1" :inactive-value="0">
                  </el-switch>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>是否门诊:{{ form.isOutPatient?'是':'否' }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="surgicalStentName" label="手术名称" v-if="getIsView()">
                <el-select v-model="form.surgicalStentId" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getOpList" @change="opChange" style="width: 100%">
                  <el-option v-for="item in opList" :key="item.id"
                    :label="item.name + ' ' + (item.categoryName == null ? '' : item.categoryName)"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>手术名称:{{ form.surgicalStentName }} </span>
            </el-col>

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="surgeryDate" label="手术时间" v-if="getIsView()">
                <el-date-picker v-model="form.surgeryDate" type="datetime" :disabled="!editMode"
                  format="yyyy-MM-dd hh:mm:ss" value-format="yyyy-MM-dd hh:mm:ss" placeholder="手术时间"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>手术时间:{{  parseTime(new Date(form.surgeryDate), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="手术医生" v-if="getIsView()">
                <el-input disabled v-model="form.doctorName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术医生:{{ form.doctorName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorNo" label="医生工号" v-if="getIsView()">
                <el-input disabled v-model="form.doctorNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>医生工号:{{ form.doctorNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" v-if="getIsView()" :prop="form.chargeCategory == 1 ? 'notes' : 'remark'">
                <el-input v-if="form.chargeCategory !== 1" :disabled="!editMode" placeholder="备注"
                  v-model="form.remark"></el-input>
                <el-input v-if="form.chargeCategory == 1" :disabled="!editMode" placeholder="备注"
                  v-model="form.notes"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeCategory" label="计费类型" v-if="getIsView()">
                <el-radio-group :disabled="!editMode" v-model="form.chargeCategory" @change="chargeCategoryChange">
                  <el-radio v-for="item in ChargeCategoryOptions" :label="item.id" :key="item.id">{{ item.name
                  }}</el-radio>
                  <!-- <el-radio :label="1">退费</el-radio> -->
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>计费类型:{{ ChargeCategoryOptions.find(item => item.id == form.chargeCategory)?.name }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeNo" label="计费单号" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="请输入计费单号" v-model="form.chargeNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>计费单号:{{ form.chargeNo }} </span>
            </el-col>
            <el-col v-if="form.chargeCategory == 1" :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="sourceNo" label="原跟台使用" v-if="getIsView()">
                <el-select v-model="form.sourceNo" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getSurgicalUses" @change="sourceChange" style="width: 100%">
                  <el-option v-for="item in surgicalUseList" :key="item.id" :label="item.no"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>原跟台使用:{{ form.sourceNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">跟台使用明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" fixed label="产品" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="120"></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>

            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="200"></el-table-column>
            <el-table-column prop="number" label="数量" width="120"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="execDeptName" label="执行科室" width="150" />
            <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="locationName" label="货位" width="120"></el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{
                  scope.row.validityDate
                    ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{
                  scope.row.manufactureDate
                    ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证"
              width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"
              width="180"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode == 1" v-preventReClick class="color-blue"
                  @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px"
        :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no"
                  @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>

                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="stockColumns"
                  :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList"
                  @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择有效期" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4"
                  :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable
                  @change="childLocationChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number"
                  :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick
            @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确
            定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData"
      @tagCodeDelete="tagCodeDelete" @close="closeLabelDetailsDialog" />
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
      @viewDetails="viewDetails" @tagCodeDelete="tagCodeDelete" @close="closePackageLabelDialog" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import ScanMixin from "@/mixin/outStockScan-mixin";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetSurgicalStents,
  SaveSurgicalUse,
  GetSurgicalUseById,
  RemoveSurgicalUse,
  RejectSurgicalUse,
  GetSurgicalUses,
  GetProducts,
} from "@/api";
import {
  ChargeCategoryOptions
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, ScanMixin, tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data () {
    return {
      form: {},
      GetDataAction: GetSurgicalUseById,
      SaveDataAction: SaveSurgicalUse,
      reject: RejectSurgicalUse,

      ChargeCategoryOptions: ChargeCategoryOptions,
      rules: {
        sourceNo: [{
          required: true,
          message: "请选择跟台使用",
          trigger: "blur",
        },],
        chargeNo: [{
          required: true,
          message: "请输入计费单号",
          trigger: "blur",
        },],
        deptName: [{
          required: true,
          message: "请选择执行科室",
          trigger: "change",
        },],
        warehouseName: [{
          required: true,
          message: "请选择仓库",
          trigger: "blur",
        },],
        notes: [{
          required: true,
          message: "请填写备注",
          trigger: "blur",
        },],
        patientNo: [{
          required: true,
          message: "请选择患者",
          trigger: "blur",
        },]
      },
      childFormRules: {
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur",
        },],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur",
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      isScan: false,

      surgicalUseList: [],
      opList: [],
      loading: false,
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()
      this.getDeptAndWards1()
    } else {
      this.getDeptsBySessionDeptId("");
      this.getDepts2();
    }

    this.getWarehousesBySessionWarehouseId("");
    this.getProductList("");
    this.getPatientDetailList("");
    this.getOpList("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.notes = res.returnData.remark;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading', true)
      if (this.form.chargeCategory == 1) {
        this.form.remark = this.form.notes;
      }
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading', false)
          return false;
        }
        this.loading = true;
        var productValidate = this.orderProductDetailRepeatValidate1(this.form.details);
        if (!productValidate.flag) {
          this.$my_message(productValidate.msg, "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }

        //校验产品是否已过期
        var productPeriodValidate = this.checkProductOverdueValidate(this.form.details);
        if (!productPeriodValidate.flag) {
          const h = this.$createElement;
          let content = [];
          content.push(
            h(
              "p", `${productPeriodValidate.msg}`,
            )
          );
          content.push(
            h(
              "p", `是否继续？`,
            )
          );
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            customClass: "promptBox",
            showCancelButton: true,
            showConfirmButton: true,
            message: h("div", content),
          }).then(() => {
            this.Save();
          }).catch((e) => {
            this.$store.dispatch('SetLoading', false)
            throw new Error(productPeriodValidate.msg);
          });
        } else {
          this.Save();
        }
      });
    },
    Save () {
      this.SaveDataAction(this.form)
        .then((res) => {

          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        })
        .finally(() => {
          this.$store.dispatch('SetLoading', false)
        });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        // warehouseCategory: "1",
        warehouseId: "", // this.userInfo.defaultWarehouseId,
        warehouseName: "", // this.userInfo.defaultWarehouseName,
        warehouseManagerId: "", // this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: "", // this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        chargeCategory: 0,
        isOutPatient: 0,
        sourceNo: "",
        sourceId: "",
        chargeDeptName: this.system_setting.IsUseWard ? `${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} ` : this.mySessionStorage.getDeptName(),
        chargeDeptId: this.mySessionStorage.getDeptId(),
        deptName: this.system_setting.IsUseWard ? `${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} ` : this.mySessionStorage.getDeptName(),
        deptId: this.mySessionStorage.getDeptId(),
        wardId: this.system_setting.IsUseWard ? this.mySessionStorage.getWardId() : '',
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode: sessionStorage.getItem('orgId'),
      };
      // if (this.system_setting.IsUseWard){

      //     this.getDeptById(this.userInfo.deptInfos[0].id).then(r=>{
      //      this.form.deptName = `${r[0].name} ${r[0].wards[0].name}`
      //       this.form.chargeDeptName = `${r[0].name} ${r[0].wards[0].name}`
      //       this.form.deptId = r[0].id
      //      this.form.wardId = r[0].wards[0].id
      //      this.form.chargeWardId = r[0].wards[0].id
      //     })
      //    }else{
      //     this.form.deptName = this.userInfo.deptInfos[0].name;
      //      this.form.deptName = this.userInfo.deptInfos[0].name;
      //    }
      //    this.$forceUpdate();

      // this.setDefaultDeptBySessionDeptId();
      this.setDefaultWarehouseBySessionWarehouseId(2);
    },
    // 取消编辑
    cancel () {
      this.$store.dispatch('SetLoading', false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      if (this.checkIsRfid(this.childMultipleSelection)) {
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        productId: "",
        specId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      //  this.getProductList("");
    },
    pushChildForm (close) {
      let result = true;
      console.log(this.childForm);
      this.$refs["childForm"].validate((valid) => {
        result = valid;
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm;
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                item.unUseNumber = childForm.unUseNumber;
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm));
            childForm.$index = this.form.details.length + 1;
            this.form.details.push(childForm);
          }
        } else {
          if (this.editChildren) {
            let item = this.form.details.find((e) => e.$index == this.childForm.$index);
            Object.assign(item, this.childForm);
          } else {
            this.form.details.push(this.childForm);
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result;
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // scan

    openScanner (ev) {
      if (!this.form.warehouseId || this.form.warehouseId == "") {
        this.$my_message("请先选择库房", "warning");
        return;
      }
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    opChange (val) {
      this.form.surgicalStentId = val;
      let arr = this.opList.filter((item) => item.id == val)[0];
      this.form.assistant = arr.assistant;
      this.form.phone = arr.phone;
      this.form.surgicalStentName = arr.name + " " + arr.categoryName
    },
    childLocationChange (val) {
      this.childForm.locationId = val;
    },
    // supplierChange (val) {
    //   this.form.supplierId = val;
    //   this.getProductList('')
    //   this.form.details = []
    // },
    warehouseChange (val) {
      this.form.warehouseId = val;
      let arr = this.STATIC_Warehouses.filter((item) => item.id == val);
      this.form.warehouseName = arr[0].name;
      this.form.warehouseCategoryName = arr[0].category == 1 ? "一级库房" : "二级库房";
      this.form.warehouseCategory = arr[0].category;
      this.form.warehouseManagerId = arr[0].managerId;
      this.form.warehouseManagerName = arr[0].managerName;

      this.getLocations(val);
      this.getProductList("");
    },
    productChange (row) {
      let id = this.childForm.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id;
      this.childForm.stockId = row.id;
      this.childForm.number = 1;
      // this.childForm.stockNumber = row.stockQuantity
      this.childForm.amount = this.childForm.price;
      this.childForm.remark = "";
      console.log(row);

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField("productName");
    },
    patientChange (val) {
      // let arr = this.STATIC_PatientDetails.filter(item => item.no == val)[0]
      let arr = this.STATIC_PatientDetails.filter((item) => item.id == val)[0];
      if (arr) {
        this.form.patientId = arr.parentId;
        this.form.patientDetailId = arr.id;
        this.form.patientName = arr.name;
        this.form.patientDeptId = arr.deptId;
        this.form.patientDeptName = arr.deptName;
        this.form.patientNo = arr.no;

        this.form.doctor = arr.doctor;
        this.form.doctorName = arr.doctorName;
        this.form.doctorNo = arr.doctorNo;
      } else {
        this.form.patientId = "";
        this.form.patientDetailId = "";
        this.form.patientName = "";
        this.form.patientDeptId = "";
        this.form.patientDeptName = "";

        this.form.doctor = "";
        this.form.doctorName = "";
        this.form.doctorNo = "";
      }
    },
    deptChange (val) {
      this.form.deptId = val;
      this.getProductList("");
    },
    applyDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards.filter(res => res.idGroup == val)
      this.form.deptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
    },
    chargeDeptChange (val) {
      this.form.chargeDeptId = val;
    },
    chargeDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards1.filter(res => res.idGroup == val)
      this.form.chargeDeptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.chargeDeptId = arr[0].deptId
      this.form.chargeWardId = arr[0].wardId
    },
    chargeCategoryChange (val) {
      this.form.sourceId = "";
      this.form.sourceNo = "";
      this.form.details = [];
      this.getSurgicalUses("");
    },
    sourceChange (val) {
      this.form.sourceId = val;
      this.form.details = [];

      GetSurgicalUseById({
        id: val,
      }).then((res) => {
        this.form.chargeDeptId = res.returnData.chargeDeptId
        this.form.chargeDeptName = res.returnData.chargeDeptName
        var details = res.returnData.details;
        if (details) {
          // details.map(item => {
          //   item.id = ''
          //   return item
          // })

          this.form.details = details;

          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
          this.autoTotalAmount();
        }
      });
    },

    getProductList (keyWord) {
      // query.warehouseId = this.form.warehouseId
      // query.category = 2
      let query = {
        keyWord: keyWord,
        warehouseId: this.form.warehouseId,
        category: 2,
        // loginDeptId: this.form.ownerDeptId,//this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      };

      if (this.form.warehouseId) {
        query.loginWarehouseId = this.form.warehouseId;
      }
      this.getStocks(query);
    },

    getSurgicalUses (keyWord) {
      var query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
        chargeCategory: 0,
        Status: 2,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      };
      GetSurgicalUses(query) //({ keyWord: keyWord, pageIndex: 1, pageSize: 100, chargeCategory: 0, status: 2 })
        .then((res) => {
          this.surgicalUseList = res.returnData.data;
        });
    },
    getOpList (keyWord) {
      var query = {
        name: keyWord,
        pageSize: 100,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      };
      GetSurgicalStents(query).then((res) => {
        this.opList = res.returnData.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
<style>
.promptBox .el-message-box__message p {
  white-space: pre-wrap;
}
</style>
